import locales from "./en_locales";

export default {
    locales,
    app: {
        name: "Whalespace Developers"
    },
    breadcrumb: "Breadcrumb",
    page: {
        home: "Home",
        guide: "Guide",
        developerRegister: "Register as developer",
        apps: "Application",
        appRegister: "Add application",
        project: "Project",
        projectJoin: "Request to join",
        projectRegister: "Create"
    },
    sidebar: {
        project: "Project",
        projectRegister: "New project"
    },
    email: "Email",
    login: "Log in",
    whale_lab: { title: "Whale Labs" },
    notices: { title: "Notice" },
    links: {
        terms: "Terms of Use",
        privacy: "Privacy Policy",
        privacy_whale: "NAVER Whale Privacy Whitepaper",
        help_naver: "Help",
        copyright_old: "\u{a9} NAVER Corp.",
        copyright: "\u{a9} NAVER Corp.",
        whale: "Whale browser",
        download: "Download",
        whale_download_mo: "Download"
    },
    menus: {
        profile: {
            register: "Register as developer",
            setting: "Account settings",
            unregister: "Unregister",
            delete: "Delete account",
            logout: "Log out"
        }
    },
    home: {

        /*
         * 개행문자는 항목/환경에 따라 white-space: pre-line으로 렌더링됩니다.
         * - title : 모바일 환경
         * - desc : pc/태블릿 환경
         * - items : pc/태블릿/모바일 환경
         */
        title: "Announcing the end of support for the WhaleSpace DevCenter",
        desc: "Whale Space Developer Center services will be discontinued.\nOnly the app information viewing feature will be supported for existing developer accounts, and API environments will receive limited support.\n\nProjects and applications from already registered developers\nwill continue to be supported until the end of official support.\n\nNew Whale Space login integration development is provided in the App Console environment. Please note this for your reference.\n\nDetailed information can be found in the announcements.",
        registerButton: "Register as developer",
        appConsoleShortcut: "Go to App console ",
        appConsoleRequest: "Requesting App console",
        noticeShortcut: "View announcements",
        obsolete: "obsolete",
        deprecated: "deprecated",
        items: {
            guide: {
                title: "Developer Guide",
                desc: `Learn how to register
                Whalespace applications.`
            },
            api: {
                title: "Whalespace API",
                desc: `Check out the open API
                available in Whalespace.`
            },
            lab: {
                title: "Whale Labs",
                desc: `Share your experiences and problems
                with other Whalespace application developers.`
            }
        }
    },
    guides: {
        versions: {
            loginApi1: "v1.0 (provided until December 2022)",
            loginApi2: "v1.1"
        },
        deprecated: {
            text1: "The Login API v1.0 was deprecated on 16 August 2024",
            text2: "Login API v1.1",
            text3: "You will need to switch to "
        },
        project: {
            text1: "서비스 지원 종료 인한 기능 제한",
            text2: "웨일 스페이스 개발자센터 서비스 지원이 종료됨에 따라, 프로젝트 및 애플리케이션 정보 확인과 API 환경은 지정된 기간까지 이용 가능하며,<br>그 외 기능은 모두 제한됩니다. 자세한 내용은 <a target='_blank' href='https://notice.naver.com/notices/whalespace/25115'>안내 공지사항</a>을 통해 확인해주시기 바랍니다."
        }
    },
    welcome: {
        title: "Congratulations,\nYour signup to Whalespace Developers is complete.",
        desc: "You're now signed up for the Whalespace Developers\nwhere you can register as a developer to manage your application and set up the API."
    },
    agreement: {
        title: "Consent to Terms of Use and Collection of Personal Information",
        agreedAll: "I accept all the terms and conditions below.",
        service: {
            title: "Consent to Terms of Use (required)",
            agree: "I have read and accept the Terms of Use."
        },
        privacy: {
            title: "Consent to Collection and Use of Personal Information (required)",
            items: [
                "Personal information to collect: (Required) e-mail, profile picture, year of birth, birth date",
                "Purpose of collection and use of personal information: To disclose developer information when your application is added to stores, and provide notices required to manage and run the stores.",
                "Retention and use of personal information: Retained during the use of the service.",
                `You may refuse to agree to the collection and use of your personal information.
                If you refuse, however, you may not be able to use the service you signed up for, or may use only part of it.`
            ],
            agree: "I have read and accept the above terms and conditions."
        },
        account: {
            helper: "The domain name of your email address in [My Info > My Profile] in NAVER must be “naver.com” to use the service. Please check your email address.",
            link: "Go to [My Profile]"
        }
    },
    label: {
        confirm: "OK",
        cancel: "Cancel",
        register: "Register",
        add: "Add",
        save: "Save",
        delete: "Delete",
        remove: "Delete",
        approve: "Approve",
        reject: "Reject",
        join: "Request to join",
        copy: "Copy",
        publish: "Issuance",
        republish: "Reissuance",
        add_member: "Add developer",
        change_admin: "Change administrator",
        unregister: "Cancel a project join request",
        delete_project: "Delete project",
        withdrawProject: "Remove from project",
        registerDeveloper: "Register as developer",
        main: "Home"
    },
    apps: {
        emptyTable: "No applications.",
        fieldName: {
            clientName: "Application",
            clientId: "Client ID",
            status: "Status",
            type: "Category"
        },
        status: {
            WAIT_APPROVAL: "Awaiting approval",
            APPROVAL: "Approved",
            REJECT_APPROVAL: "Approval rejected",
            WAIT_UPDATE: "Awaiting update",
            REJECT_UPDATE: "Update rejected",
            HOMEPAGE_DEPLOYED: "Deployed on homepage"
        },
        type: {
            WEB_APP: "Web application",
            ANDRIOD: "Android",
            IOS: "iOS",
            DESKTOP_APP: "Desktop app"
        },
        labels: {
            registerApp: "Register application"
        }
    },
    appRegister: {
        guide: {
            register:
                "We will decide whether to approve your application after reviewing the following information you provide.",
            WAIT_APPROVAL:
                "The application information you submitted is <em>under review</em>.",
            REJECT_APPROVAL: "The application approval is <em>rejected</em>.",
            REJECT_UPDATE: "The update is <em>rejected</em>.",
            REJECT_MESSAGE: "(reason: {statusMessage})"
        },
        cancelRegister: {
            title: "Unregister application",
            content: "This will delete all unsaved changes."
        },
        saveRegister: {
            title: "Register application",
            content:
                "We will decide whether to approve your application after reviewing the information you provide. Do you want to register the application?"
        },
        label: {
            delete: "Delete",
            edit: "Edit information",
            reRegister: "Re-register"
        }
    },
    appDetail: {
        tabs: {
            overview: "Overview",
            information: "Homepage display info",
            api: "API",
            customers: "Institutions"
        },
        label: {
            uploadImage: "Add image",
            update: "Request update",
            cancelUpdate: "Cancel request",
            required: "Required fields",
            optional: "Optional fields",
            default: "Default",
            defaultLanguage: "Default language",
            defaultLanguageSetting: "Set default language"
        },
        fieldName: {
            status: "Application status",
            clientName: "Application name",
            redirectUri: "Redirect URI",
            clientId: "Client ID",
            clientSecret: "Client Secret",
            apiKey: "API key",
            description: "Brief description",
            categories: "Category",
            project: "Project name",
            companyUrl: "Company URL",
            serviceUrl: "Service URL",
            serviceInfoUrl: "Service description URL",
            servicePrice: "Service pricing plan",
            version: "Version information",
            explanation: "Detailed description",
            iconUrl: "Icon image",
            serviceImageUrl: "Main image",
            offeredData: "API information",
            languages: "Set homepage display languages",
            availableLanguages: "Available languages",
            selectLanguage: "Select language"
        },
        placeholder: {
            clientName: "Enter an application name.",
            description: "Enter a brief description.",
            companyUrl: "Enter a company URL.",
            serviceUrl: "Enter a service URL.",
            serviceInfoUrl: "Enter a service description URL.",
            categories: "Select a category.",
            project: "Select a project name.",
            servicePrice: "Select a pricing plan.",
            version: "Enter version information.",
            explanation: "Enter a detailed description.",
            languages: "Search languages"
        },
        categoriesGuide: "Up to 3 categories",
        imageGuide:
            "Recommended image size: {0} x {1} px / gif, png, jpg (jpeg)",
        imageCountGuide: " / up to 6 images",
        languagesGuide:
            "Sets homepage display languages and affiliate services by language. The ones that match the browser languages take priority; if there are no matching languages, the default language is applied.",
        requiredFieldsGuide:
            "All required fields must be specified for each language.",
        clientSecret: {
            show: "Show",
            hide: "Hide",
            reissuance: "Reissue"
        },
        changeDefaultLanguage: {
            title: "Set default language",
            content: "Do you want to change the default language?"
        },
        api: {
            access: "Permissions",
            required: "Required",
            optional: "Optional",
            offeredData: {
                guide: "Account ID provided by default",
                tempGuide:
                    "Required or optional settings will be enabled later.",
                title: {
                    name: "Name",
                    thumbnailPhotoUrl: "Profile image",
                    userType: "User type",
                    space: "Institution information",
                    userOrgunits: "Organization information",
                    number: "Unique number",
                    relation: "Relation information"
                },
                detail: {
                    userType: "Title",
                    space: "Office of education, School",
                    userOrgunits: "Grade, Class",
                    number: "Number"
                }
            },
            addRedirectUri: "Add redirect URI",
            cancelRedirectUri: {
                title: "Cancel redirect URI",
                content: "This will delete all unsaved changes."
            },
            emptyRedirectUri: {
                title: "Redirect URI",
                content: "No redirect URIs. Enter a redirect URI."
            },
            saveRedirectUri: "Changes have been saved."
        },
        information: {
            cancelInformation: {
                title: "Cancel update",
                content:
                    "This will delete all unsaved changes in [Homepage display info]."
            },
            saveInformation: {
                title: "Update",
                content:
                    "Your application will be updated on Affiliates of Whalespace after being reviewed based on the information you provide. Do you want to request an update?"
            },
            invalidInputFields: {
                title: "Update",
                content:
                    "All required fields must be specified for each language. Please check your entries."
            }
        },
        servicePrice: {
            PAID: "Paid",
            FREE: "Free",
            PARTIAL_PAID: "Freemium"
        },
        deleteApplication: {
            title: "Delete application",
            content:
                "Deletes the application. A deleted application cannot be recovered."
        },
        customers: {
            guide: "You can select institutions to apply your application to.\nThen, your application will be exposed on {0} of Whalespace and on Whalespace Admin of the selected institutions.",
            link: "Affiliates",
            notice: {
                title: "Notice!",
                content:
                    "This menu only controls whether to expose your application to the specified institutions. It cannot block users (domains) of other institutions from accessing the application."
            },
            type: {
                EDU_OFF: "Office of education",
                EDU_KND: "Kindergarten",
                EDU_ELEM: "Elementary school",
                EDU_MS: "Middle school",
                EDU_HS: "High school",
                EDU_UNIV: "University",
                EDU_OTHER: "Etc.",
                EDU: "Education",
                CORP: "Corporate"
            },
            allCustomerType: "All institutions",
            list: "List of institutions",
            table: {
                header: {
                    unSelected: "Institutions",
                    selected: "Selected ({count})"
                },
                empty: {
                    unSelected: "All institutions have been selected.",
                    selected:
                        "No institutions selected.\nSelect an institution."
                }
            },
            cancelUpdate: {
                title: "Cancel changes",
                content: "This will delete all unsaved changes."
            },
            notModified: {
                title: "Save institutions",
                content: "No institutions selected. Select an institution."
            },
            saveUpdate: "Your changes have been saved."
        }
    },
    projects: {
        fieldName: {
            name: "Project name",
            appCount: "Application",
            status: "Status"
        },
        appCount: "{0} applications",
        status: {
            USER: "Developer",
            ADMIN: "Administrator",
            WAIT_APPROVAL: "Awaiting approval"
        },
        emptyMessage: "No project.",
        actions: {
            register: "Create",
            join: "Request to join a project"
        }
    },
    project: {
        tabs: {
            "overview": "Overview",
            "apps": "Application",
            "service-accounts": "Service Account"
        },
        name: {
            title: "Project name",
            placeholder: "Enter a project name."
        },
        code: {
            title: "Project code",
            placeholder: "Enter a project code.",
            info: "This code is used to manage Whalespace test accounts. It must be 6-13 characters long and can only contain English letters, numbers, hyphen (-) and underscore (_)."
        },
        register: {
            empty_search: "No project."
        },
        admin: {
            title: "Administrator",
            helper: "Administrator cannot be deleted."
        },
        members: {
            title: "Developer",
            placeholder: "Enter a NAVER account."
        },
        add_member: {
            helper: "Add a developer’s NAVER account."
        },
        wait_approval: {
            title: "Register developer"
        },
        pending: {
            title: "Project join request completed",
            des: "Waiting to be approved by the administrator of <em>{projectName}</em>."
        },
        updateInfo: {
            save: "The project information has been changed.",
            cancel: {
                title: "Confirm save",
                content: `You have unsaved changes.
                Do you want to continue?`
            }
        },
        account: {
            desc: "You can get a Whalespace administrator account to create test accounts as needed in Whalespace Admin.",
            howToUse: "",
            howToUseShortcut: "how to use Whalespace Admin",
            adminShortcut: "Go to Whalespace Admin",
            confirm:
                "I understand that this is for testing purposes only and Whalespace is not responsible for any problems that occur during testing.",
            create: "Get administrator account",
            id: "ID",
            password: "Password",
            forgotPassword: "Forgot your password?"
        },
        error: {
            register: {
                DUPLICATED_LABEL_NAME:
                    "A project with the same name exists. Please enter a different name.",
                DUPLICATED_NAME: "Code already in use."
            },
            join: {
                DUPLICATED_LABEL_NAME: "You are already joined."
            }
        }
    },
    serviceAccounts: {
        scope: {
            "admin.directory.space.readonly":
                "Space/School List and Detailed View",
            "admin.directory.orgunit.readonly":
                "Organization list and detailed View",
            "admin.directory.user.readonly": "List of users View",
            "admin.directory.device.readonly": "List of devices View",
            "admin.directory.browser.readonly": "List of managed browsers View",
            "admin.directory.space": "Space/School List and Edit",
            "admin.directory.orgunit": "Organization list and Edit",
            "admin.directory.user": "List of users View and Edit",
            "admin.directory.device": "List of devices View and Edit",
            "admin.directory.browser": "List of managed browsers View and Edit"
        },
        scopePostfix: " and {0} others",
        fieldName: {
            account: "Service Account",
            clientId: "Client ID",
            clientSecret: "Client Secret",
            customer: "Space",
            apiKey: "API key",
            scope: "Authorization scope",
            accountName: "Service Name",
            privateKey: "Secret Key"
        },
        emptyTable: "No service accounts.",
        labels: {
            createAccount: "Add Service Account",
            deleteAccount: "Delete Service Account",
            list: "List"
        },
        placeholder: {
            account: "Enter a service account.",
            accountName: "Enter a service name.",
            privateKey: "The secret key can be issued after account creation."
        },
        tooltip: {
            account:
                "Service accounts can only be registered with alphanumeric characters and cannot be modified after registration."
        },
        create: {
            title: "서비스 계정 생성불가",
            content:
                "서비스 지원 종료로 인해 신규 서비스계정 생성이 불가능합니다.",
            description:
                "관련 문의는 dl_whalespace_devcenter@navercorp.com 메일로 문의 부탁드립니다."
        },
        delete: {
            title: "Delete Service Account",
            description:
                "Deleting a service account deletes all institutional information and access provided by that account. Are you sure you want to delete?"
        },
        privateKey: {
            title: "Issuing a secret key",
            description:
                "The secret key is an important file for server authentication, so make sure it is not leaked to the outside world. Once issued, it will not be reissued with the same key, and you will not be able to use the old key when it is reissued.\n\nPress 'OK' and the file with the secret key will be downloaded."
        }
    },
    deleteAccount: {
        title: "Delete Whalespace developer account",
        content: {
            admin: "Deleting your developer account will delete all your personal information including an email address and project name; you can no longer register, edit and update applications. Please read and confirm the following terms.",
            developer:
                "Deleting your developer account will delete all your personal information including an email address and project name; you can no longer register, edit and update applications. A developer account once deleted cannot be recovered.",
            undeletable:
                "You need to first delete all your applications and projects you registered or change the administrator to another one to delete your developer account."
        },
        notice: [
            "You can revoke your consent to collect and use personal information only after deleting all your applications and projects you registered.",
            "All your application registration history will be deleted one day after your consent is revoked.",
            "The deleted account cannot be recovered and all its application information is completely deleted."
        ],
        confirm: {
            admin: "I have read and understood the above terms and conditions.",
            developer: "I have read and understood the terms and conditions."
        }
    },
    reissueClientSecret: {
        title: "Reissue Client Secret",
        content:
            "Deletes the current key and reissues a new one. The previous key is no longer available."
    },
    changeAdmin: {
        title: "Change administrator",
        content:
            "Transfers administrator permissions to the selected developer. The transfer of administrator permissions cannot be revoked.",
        select: "Select",
        developer: "Developer"
    },
    deleteProject: {
        title: "Delete project",
        undeletable:
            "You need to first delete all the applications and developers you registered to delete the project.",
        content: "Do you want to delete “{projectName}”?"
    },
    withdrawProject: {
        title: "Remove from project",
        content: "Do you want to remove your account from “{projectName}”?"
    },
    invalidLoginInfo: {
        title: "Confirm account information",
        content:
            "To use Whalespace Developers, you need to agree to provide the following required information.",
        data: {
            title: "Required fields",
            content: "Email address, profile picture"
        },
        detail: "To go through the consent process again, disconnect your account from Whalespace Developers on ‘{0}’ of [NAVER > My info].",
        link: "Apps/Sites connected with NAVER"
    },
    news: {
        title: "웨일 스페이스 개발자센터 이용 약관 변경 안내",
        content: "",
        detail: `웨일 스페이스 개발자센터 이용약관이 2023년 5월 1일 자로 변경 적용될 예정입니다. 이에 따라 현재 적용 중인 이용 약관은 개정일을 기준으로 새로운 이용 약관으로 대체됩니다.
        
        변경되는 주요 사항은 아래 링크를 통해서 확인하실 수 있습니다.`,
        button: "변경 사항 자세히 보기"
    },
    error: {
        email: "Check the email address you typed.",
        projectName: "Check the project name you typed.",
        appName: "Duplicate application name. Check the name you typed.",
        imageCount: "You can add up to 6 main images.",
        unknown: "Unknown error.",
        valueMissing: {
            projectName: "The project name is required.",
            projectCode: "The project code is required.",
            accountName: "Service name is required.",
            account: "Service account is required."
        },
        patternMismatch: {
            projectName:
                "The project name contains special characters that cannot be used.",
            projectCode:
                "The code must be 6-13 characters long and can only contain English letters, numbers, hyphen (-) and underscore (_).",
            account:
                "Service account can only contain English letters, numbers."
        },
        alreadyInUse: {
            name: "Name already in use.",
            account: "Account already in use."
        },
        INVALID_PROJECT_CODE: "The project code is invalid.",
        DUPLICATED_NAME: "Name already in use."
    },
    alertCreate: {
        project: {
            title: "Unable to create a project",
            content:
                "Due to the end of service support, we are unable to register new projects.\n\nFor related inquiries, please contact dl_whalespace_devcenter@navercorp.com."
        },
        application: {
            title: "Unable to register applications",
            content:
                "Due to the end of service support, we are unable to register new applications.\n\nFor related inquiries, please contact dl_whalespace_devcenter@navercorp.com."
        }
    }
};
